<template>
  <div class="bigTraffic">
    <div class="firstLine">
      <span class="title" v-for="(item,index) in bigTrafficTypes" 
        :style="checkType!=index?'background: #e4ab97;':''" :key="index" @click="checkType=index">{{item.stateName}}</span>
      <el-radio style="margin-left:0.3rem" label="1">单程</el-radio>
      <el-radio label="2">往返</el-radio>
      <el-radio label="3">多程(含缺口程)</el-radio>
    </div>
    <div class="searchDiv">
      <div class="inputDiv">
        <div class="left">
          <p>
            出发城市：<el-input style="width:2rem" placeholder="带入当天的第一个城市" size="mini"></el-input>
          </p>
          <p>
            抵达城市：<el-input style="width:2rem" placeholder="带入当天的第一个城市" size="mini"></el-input>
          </p>
        </div>
        <div class="middle">
          <p class="top"></p>
          <p class="font">换</p>
          <p class="button"></p>
        </div>
        <div class="right" style="margin-left:0.15rem">
          <p>
            出发日期：<el-date-picker type="date" placeholder="选择日期" size="mini"></el-date-picker>
          </p>
          <p>
            返程日期：<el-date-picker type="date" placeholder="选择日期" size="mini"></el-date-picker>
          </p>
        </div>
      </div>
      <div class="selectDiv">
        仓位等级：
        <el-input style="width:1rem" placeholder="儿童" size="mini"></el-input>
        <el-input style="width:1rem" placeholder="儿童" size="mini"></el-input>
        <el-input style="width:1rem" placeholder="儿童" size="mini"></el-input>
        <span class="searchBtn">搜 索</span>
      </div>
    </div>
    <div class="btnDiv">
      <div @click="addTraffic">添加自行采购的交通产品</div>
      <div>向众多票代一键询价</div>
    </div>
    <add-big-traffic ref="addBigTraffic"></add-big-traffic>
  </div>
</template>

<script>
import addBigTraffic from './addProductDialog/addBigTraffic.vue'
export default {
  components: { addBigTraffic },
  data(){
    return{
      bigTrafficTypes:[{
        state:1,
        stateName:'飞机',
        stateProductLabel:'参考航班',
        stateProtName:'机场',
        radioList:[{
          name:'单程',
          value:1
        },{
          name:'往返',
          value:2
        },{
          name:'多程(含缺口程)',
          value:3
        }],
        siteStepList:['经济/超经舱','公务/头等舱','公务舱','头等舱']
      },{
        state:2,
        stateName:'火车',
        stateProductLabel:'参考车次',
        stateProtName:'车站',
        radioList:[{
          name:'单程',
          value:1
        },{
          name:'多程',
          value:3
        }],
        siteStepList:['商务座','一等座','二等座','高级软卧','软卧','卧铺','硬座','动卧','无座']
      },{
        state:3,
        stateName:'轮船',
        stateProductLabel:'轮船编号',
        stateProtName:'港口',
        radioList:[{
          name:'单程',
          value:1
        },{
          name:'多程',
          value:3
        }],
        siteStepList:['双人外舱','双人内舱','豪华舱','高级海景舱']
      }],
      checkType:0,
    }
  },
  methods:{
    addTraffic(){
      this.$refs.addBigTraffic.beforeOpen(this.bigTrafficTypes[this.checkType])
    }
  }
}
</script>

<style lang="scss" scoped>
.bigTraffic{
  .firstLine{
    .title{
      display: inline-block;
      width: 0.35rem;
      height: 0.35rem;
      line-height: 0.35rem;
      text-align: center;
      color: #fff;
      font-weight: bold;
      background: #db4e1a;
      margin-right: 0.05rem;
    }
    /deep/ .el-radio__label{
      padding-left: 0 !important;
      color: black;
    }
  }
  .searchDiv{
    background: #f7f7f7;
    margin-top: 0.1rem;
    .inputDiv{
      padding: 0.05rem;
      display: flex;
        .left,.right{
        >p:first-child{
          margin-bottom: 0.1rem;
        }
      }
      .middle{
        .top{
          border-top: 1px solid #ddd;
          width: 0.15rem;
          height: 0.1rem;
          border-right: 1px solid #ddd;
          margin-top: 0.14rem;
        }
        .button{
          border-bottom: 1px solid #ddd;
          width: 0.15rem;
          height: 0.1rem;
          border-right: 1px solid #ddd;
        }
        .font{
          text-align: center;
          border: 1px solid #ddd;
          color: #ddd;
          width: 0.2rem;
          height: 0.2rem;
          line-height: 0.2rem;
          border-radius: 4px;
          margin-left: 0.04rem;
          font-size: 0.12rem;
          cursor: pointer;
        }
      }
    }
    .selectDiv{
      border-top: 1px dotted #ddd;
      padding: 0.05rem;
      >div{
        margin-right: 0.05rem;
      }
      .searchBtn{
        margin: 0 0.15rem;
        text-shadow: 2px 2px 5px #999;
        color: #f54402;
        font-weight: bold;
        cursor: pointer;
      }
    }
  }
  .btnDiv{
    display: flex;
    border: 1px solid #2577e3;
    border-radius: 10px;
    margin-top: 0.05rem;
    >div{
      width: 100%;
      cursor: pointer;  
      text-align: center;
      color: #2577e3;
      padding: 0.11rem;
    }
    >div:first-child{
      border-right: 1px solid #2577e3;
    }
  }
}
</style>